import { render } from "./carterDashboard.vue?vue&type=template&id=67d027c8&scoped=true"
import script from "./carterDashboard.vue?vue&type=script&lang=js"
export * from "./carterDashboard.vue?vue&type=script&lang=js"

import "./carterDashboard.vue?vue&type=style&index=0&id=67d027c8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67d027c8"]])

export default __exports__